import React, { useEffect, useState } from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, BillingActionCreators, IApplicationState, IOpoAddUpdateRequest, IOpoLookupDataResponse, IOpoResponse, IValidateAchRoutingNumberResponse, OpoActionCreators } from '@nkr/store/index';
import { IBaseResponse, IOptnRegion, IState, IUser } from '@nkr/models/index';
import { Alert, Button, Col, Form, FormGroup } from 'react-bootstrap'
import { IAddEditState, initialState } from './add-edit/add-edit-state';
import { FormProvider, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { AddEditFormWrapper } from './list/styles';
import OpoContent from './add-edit/content';

interface IProps {
}

interface IStateProps {
    user: IUser
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<IOpoLookupDataResponse>,
    getByUserId: (id: number) => Promise<IOpoResponse>,
    update: (id: number, request: IOpoAddUpdateRequest) => Promise<IBaseResponse>,
    validateAchRoutingNumber: (achRoutingNumber: string) => Promise<IValidateAchRoutingNumberResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const OpoUserOpoEdit = (props: TProps) => {
    const methods = useForm<IAddEditState>({ defaultValues: initialState, mode: 'onSubmit' });
    const { control, handleSubmit, reset, watch, formState: { errors, isDirty, isValid, isSubmitted } } = methods;

    const [opoId, setOpoId] = useState(0);
    const [stateList, setStateList] = useState<IState[]>([]);
    const [optnRegionList, setOptnRegionList] = useState<IOptnRegion[]>([]);

    const formData = watch();

    useEffect(() => {
        const getData = () => {
            props.showLoading('One moment please...').then(async () => {
                let lookupDataResponse = await props.getLookupData();

                if (lookupDataResponse.data.success) {
                    setStateList(lookupDataResponse.data.results.stateList);
                    setOptnRegionList(lookupDataResponse.data.results.optnRegionList);
                }

                let response = await props.getByUserId(props.user.id);

                if (response.data.success) {
                    let { id } = response.data.results;

                    reset(response.data.results);

                    setOpoId(id);
                }

                props.hideLoading();
            });
        };

        getData();
    }, []);

    const handleSave = () => {
        props.showLoading('Updating your information, one moment please...').then(() => {
            props.update(opoId, formData).then(response => {
                if (response.data.success) {
                    toast.success('Your information was updated successfully');
                }

                props.hideLoading();
            });
        });
    };

    return (
        <div className='container'>
            {isSubmitted && !isValid && (
                <FormGroup style={{ margin: 0 }}>
                    <Col xs={12}>
                        <Alert bsStyle='danger' bsSize='sm'>The items in red are required to continue...</Alert>
                    </Col>
                </FormGroup>
            )}

            <FormGroup>
                <Col xs={12}>
                    <h2>Update Information for your Organization</h2>
                </Col>
            </FormGroup>

            <div style={{ border: '1px solid #ddd', borderRadius: 4, padding: '20px', marginBottom: 20 }}>
                <FormProvider {...methods}>
                    <AddEditFormWrapper horizontal onSubmit={handleSubmit(handleSave)}>
                        <OpoContent
                            isOpo={true}
                            stateList={stateList}
                            optnRegionList={optnRegionList}
                            validateAchRoutingNumber={props.validateAchRoutingNumber}
                        />
                    </AddEditFormWrapper>
                </FormProvider>
            </div>

            <FormGroup>
                <Col xs={4}></Col>
                <Col xs={4}><Button bsStyle='primary' block onClick={handleSubmit(handleSave)}>Save</Button></Col>
                <Col xs={4}></Col>
            </FormGroup>
        </div>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        user: state.app.user
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getLookupData: () => {
            return dispatch(OpoActionCreators.getLookupData());
        },
        getByUserId: (id) => {
            return dispatch(OpoActionCreators.getByUserId(id));
        },
        update: (id, request) => {
            return dispatch(OpoActionCreators.update(id, true, request));
        },
        validateAchRoutingNumber: (achRoutingNumber) => {
            return dispatch(BillingActionCreators.validateAchRoutingNumber(achRoutingNumber));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(OpoUserOpoEdit);